import axios from 'axios'




function getapi () {
let apiUrl = ''

if (window.location.protocol === 'https:') {
apiUrl = 'https://' + window.location.host + '/api/wx/'
} else {
apiUrl = 'http://af.aimtyiot.cn:48887/api/wx/'
}
if (window.location.host.split(':')[0] === 'localhost') {
apiUrl = 'http://af.aimtyiot.cn:48887/api/wx/'
}
return apiUrl
}

const service = axios.create({
baseURL: getapi(), // api的base_url
timeout: 5000 
})


service.interceptors.request.use(config => {
return config
}, error => {

console.log(error) 
Promise.reject(error)
})


service.interceptors.response.use(
response => {
/**
* code为非20000是抛错 可结合自己业务进行修改
*/
const res = response.data

if (res.code !== 200) {

if (res.code === 20001 || res.code === 20002 || res.code === 20003 || res.code === 20004 || res.code === 20007 || res.code === 30006) {

window.selt.golobleObject.getHintOpen(res)
} else {
return response.data
}
return Promise.reject(new Error('error'))
} else {
return response.data
}
},
error => {
console.log('error', error.response)
if (error.response.data.code === 20001 || error.response.data.code === 20002 ||
error.response.data.code === 20003 || error.response.data.code === 20004 ||
error.response.data.code === 20007 || error.response.data.code === 30006) {


window.selt.golobleObject.getHintOpen(error.response.data)
}
return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/util/request.js